export default vm => ({
  installationData: [
    {
      text: vm.$t('fields.installation.complex'),
      value: 'complex',
    },
    {
      text: vm.$t('fields.installation.coordinates'),
      value: 'coordinates',
    },
    {
      text: vm.$t('fields.installation.federative-unit'),
      value: 'state',
    },
  ],
  assetRegistrationData: [
    {
      text: vm.$t('asset-information.asset-info.operation-entry'),
      value: 'operationEntry',
    },
    {
      text: vm.$t('asset-information.asset-info.asset-description'),
      value: 'assetDescription',
    },
    {
      text: vm.$t('asset-information.asset-info.serial-number'),
      value: 'serialNumber',
    },
    {
      text: vm.$t('asset-information.asset-info.installation-code'),
      value: 'installationCode',
    },
    {
      text: vm.$t('asset-information.asset-info.operational-code'),
      value: 'operationalCode',
    },
    {
      text: vm.$t('asset-information.asset-info.operative-position'),
      value: 'operativePosition',
    },
    {
      text: vm.$t('asset-information.asset-info.manufacturer'),
      value: 'manufacturer',
    },
    {
      text: vm.$t('asset-information.asset-info.model'),
      value: 'model',
    },
    {
      text: vm.$t('asset-information.asset-info.manufacturing-year'),
      value: 'manufactureYear',
    },
    {
      text: vm.$t('fields.general.observations'),
      value: 'observation',
    },
  ],
});
